import { render, staticRenderFns } from "./ManualUpdateIpt.modal.vue?vue&type=template&id=188ad389&scoped=true&"
import script from "./ManualUpdateIpt.modal.vue?vue&type=script&lang=ts&"
export * from "./ManualUpdateIpt.modal.vue?vue&type=script&lang=ts&"
import style0 from "./ManualUpdateIpt.modal.vue?vue&type=style&index=0&id=188ad389&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ad389",
  null
  
)

export default component.exports